// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import axios from 'axios'
import VueWechatTitle from 'vue-wechat-title'
import noNet from './components/emptypage/noNet/index'
import connectionFail from './components/emptypage/connectionFail/index'
import { Lazyload, Row, Col, Icon, Field, Button, Cell, CellGroup, Toast, Dialog, Stepper,
  ActionSheet, RadioGroup, Radio, TreeSelect, Checkbox, CheckboxGroup,
  Rate, Uploader, AddressList, Search, List, CountDown, PullRefresh,Divider,Overlay,Progress,DatetimePicker,Picker,Sticky, Popup } from 'vant'
import 'vant/lib/index.css'
import './assets/common/css/popUp.less'
import { getCookie } from './assets/common/js/config'
import { customRequestAjax } from '@/axiosApi'

//粘贴板插件，通常用于进行文案复制分享的
import clipboard from 'clipboard';
Vue.prototype.clipboard = clipboard;
// import $ from 'jquery'
// import VConsole from 'vconsole/dist/vconsole.min.js' // import vconsole
// let vConsole = new VConsole() // 初始化
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded' // post数据请求
Vue.prototype.path = 'https://gxbprep.xlmsxs.com/'
import echarts from 'echarts'
Vue.prototype.ossUrl = 'https://gxbprep.xlmsxs.com/api/Sysinfopre/getOssWeb' // OSS
Vue.prototype.ossImgUrl = 'https://img.xlmsxs.com/'
Vue.prototype.$echarts = echarts
Vue.prototype.$axios = axios
Vue.prototype.$customRequestAjax = customRequestAjax
Vue.use(VueWechatTitle)
Vue.use(noNet) // 啊哦，网络不太顺畅哦～
Vue.use(connectionFail) // 啊哦，服务器连接失败～
Vue.use(Lazyload, {
  preLoad: 1,
  error: require('./assets/images/20200611124132.jpg'),
  loading: require('./assets/images/20200611124132.jpg'),
  attempt: 1
}).use(Row).use(Col).use(Icon).use(Field).use(Button).use(Cell).use(CellGroup).use(Toast).use(Dialog).use(Stepper).use(ActionSheet).use(Sticky)
  .use(RadioGroup).use(Radio)
  .use(TreeSelect).use(Checkbox)
  .use(CheckboxGroup).use(Rate)
  .use(Uploader).use(AddressList)
  .use(Search).use(List)
  .use(CountDown).use(PullRefresh).use(Divider).use(Overlay).use(Progress).use(DatetimePicker).use(Picker).use(Popup)
Vue.prototype.pagesize = 10
Vue.prototype.errorHeadImg = require('./assets/images/errorheadimg.png')
Vue.prototype.errordImg = require('./assets/images/dimg.jpg')
Vue.config.productionTip = false

router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  const agent = navigator.userAgent
  const isiOS = !!agent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) // ios终端
  if (to.meta.title) {
    document.title = to.meta.title
  }
  if(getCookie('wxmalltoken') && location.pathname == '/login'){
    if(!!getCookie('wxmalltype') && getCookie('wxmalltype')==0){
      window.location = '/profile'
    }else{
      window.location = '/activity'
    }
  }
  if(!getCookie('wxmalltoken') && location.pathname != '/login'){
    window.location = '/login'
  }else{
    if (isiOS && to.path !== location.pathname) {
      location.assign(to.fullPath)
    } else {
      next()
    }
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js